import { GridRow, type GridApiPro, useGridApiRef } from '@mui/x-data-grid-pro';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { PlanOverview } from '@vy/api-definition';
import { isNotNullOrUndefined, withDefault } from '@vy/utils';
import React, { type MutableRefObject, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import type { VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/vy-table-types';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';
import { usePlansOverviewsWithPageParams } from '../../../../hooks/requests/use-plans-overview/use-plans-overviews';
import { useTableSorting } from '../../../../hooks/use-table-sorting';
import { getPlansOverviewsColumns } from '../plans-page-consts/plans-columns';
import { PlansEmptyState } from '../../../../components/new-design/data-display/PlansEmptyState.tsx';
import { Box } from '@mui/material';

type PlansOverviewTableProps = Omit<VyTableMinimalProps<PlanOverview>, 'tableName'> & {
  isPlanFilterOpen: boolean;
};

export const PlansOverviewTable: React.FC<PlansOverviewTableProps> = (props) => {
  const { refetch: refetchPlansOverview } = usePlansOverviewsWithPageParams({
    page: withDefault(props.page, 0),
    pageSize: withDefault(props.pageSize, 10),
  });
  const { handleSortModelChange } = useTableSorting();

  const apiRef = useGridApiRef();
  const columns = getPlansOverviewsColumns(refetchPlansOverview, apiRef as MutableRefObject<GridApiCommunity>);

  useEffect(() => {
    if (isNotNullOrUndefined(apiRef.current)) {
      const firstRowId = apiRef.current.getRowIdFromRowIndex(0);
      apiRef.current.selectRow(firstRowId);
    }
  }, [apiRef]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <VyTable
        tableName="plans-overview"
        apiRef={apiRef as React.MutableRefObject<GridApiPro>}
        columns={columns}
        noRowsOverlay={PlansEmptyState}
        slots={{
          row: (rowProps) => (
            <NavLink to={`${rowProps.rowId}`}>
              <GridRow {...rowProps} />
            </NavLink>
          ),
        }}
        onSortModelChange={handleSortModelChange}
        {...props}
      />
    </Box>
  );
};
